import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationType } from '../../enum/notification-type.enum';
import { NotificationService } from 'src/app/service/notification.service';
import { forkJoin, Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ResponseData } from 'src/app/models/commission/response-data.model';
import { Buttons } from 'src/app/home/table/Buttons';
import { Totals } from 'src/app/home/table/Totals';
import { CommissionSummaryService } from 'src/app/service/commission-summary.service';
import { UploadJsonModel } from 'src/app/models/commissionsummary/upload-json.model';
import { CommSummaryModel } from 'src/app/models/commissionsummary/commsummary.model';
import { WorkFlowMessageModel } from 'src/app/models/commissionsummary/workflowmessage.model';
import { UploadJsonHeadersModel } from 'src/app/models/commissionsummary/upload-json-headers.model';
import { GlobalService } from 'src/app/service/global.service';
import { NgForm } from '@angular/forms';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { ApprovalFlowService } from 'src/app/admin-portal/approval-flow-models/approval-flow.service';
import { MissingDisputesModel } from 'src/app/models/commission/missingdisputes.model';
import { Kpimaster } from 'src/app/models/commission/kpimaster.model';

import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { MissingDisputesService } from 'src/app/service/missingdisputes.service';
import * as XLSX from 'xlsx';
import { DataService } from 'src/app/service/prevdata.service';
import { getCurrencyInfo, applyCurrencySymbolOverride } from 'src/app/service/currency.util';
import { ReviewCommissionsService } from 'src/app/service/commission-summary/review-commissions.service';

@Component({
  selector: 'app-review-commissions',
  templateUrl: './review-commissions.component.html',
  styleUrls: ['./review-commissions.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class ReviewCommissionsComponent implements OnInit {
  //[x: string]: any;
  constructor(private dataService: DataService, private _location: Location, private globalService: GlobalService, private router: Router,
    private notificationService: NotificationService,
    private route: ActivatedRoute, private commissionSummaryService: CommissionSummaryService,
    private approvalFlowService: ApprovalFlowService, private missingDisputesService: MissingDisputesService, public ete: ExportExcelService) {
    globalService._disableBackButton();
  }

  public commSummaryModel = new CommSummaryModel();
  public commSummary_Model = new CommSummaryModel();
  public uploadJsonHeadersModel = new UploadJsonHeadersModel();
  public workFlowMessageModel = new WorkFlowMessageModel();
  public addMissingDisputes = new MissingDisputesModel();
  public contentMessage: WorkFlowMessageModel;

  public missingDisputesModel = new MissingDisputesModel();
  public missingDisputesModel1 = new MissingDisputesModel();
  public jsonListData: UploadJsonModel[] = [];
  public headersData: UploadJsonHeadersModel[];
  public buttonsData: UploadJsonHeadersModel[];
  public calcRunningStatus: UploadJsonHeadersModel[];
  public supStatus: UploadJsonHeadersModel[];
  public pageNameList: UploadJsonHeadersModel[];
  public headersData1: UploadJsonHeadersModel[];
  public buttonsData1: UploadJsonHeadersModel[];
  public excelData: CommSummaryModel[];
  public missingModels: MissingDisputesModel[] = [];
  public kpis: Kpimaster[];
  public filterKPiData: Kpimaster[] = [];
  public ordersTableColumns: TableColumn[];
  public ordersTableColumns2: TableColumn[];
  public buttons: Buttons[];
  public totals: Totals[];
  private subscriptions: Observable<CommSummaryModel[]>[] = [];
  public responseList: ResponseData[] = [];

  public backBtnResponseListUsers: ResponseData[] = [];
  public backBtnResponseListKpis: ResponseData[] = [];
  public listKpisBackupCommPlanId: number = 0;
  public listKpisBackupSearchEmpParm: string = '';
  public listKpisBackupSearchParms: string = '';

  public responseList1: ResponseData[] = [];
  public responseListSort: ResponseData[] = [];
  public ordersTableExcelHeaderColumns: TableColumn[];

  public mySalesChannelSet = new Set<string>();
  public searchCriteriaSet = new Set<string>();

  public vkpiid: string = "";
  public recordType: string = "";
  public checkedactive: boolean = false;


  public columnsData: any;
  public totalView: string = "";
  public adjustmentCommValue: any;


  public jsonData: any;
  public totResData: any;
  public totResData1: any;
  public totResData2: any;
  public compareDispute: any;
  public finalResponseData: any;
  public totalstatus: number;
  public tot1: any;
  public disputeMsg: string;

  public dscempid: any;
  public dcorp: any;
  public dhouse: any;
  public dcust: any;
  public dtrackid: any;
  public dkomffeedid: any;
  public daccnum: any;

  public view_dscempid: any;
  public view_dcorp: any;
  public view_dhouse: any;
  public view_dcust: any;
  public view_dtrackid: any;
  public view_dkomfeedid: any;
  public view_daccnum: any;

  public showLoading: boolean;
  public showCheckBox: boolean = false;
  public isDisBtnDisabled: boolean = true;
  public isExcelBtnDisabled: boolean = false;
  public calcStatus: string;
  public isCalcRunning: boolean = false;
  public supervisorStatus: string;
  // public btnLength: number = 1;
  public isNoDataFound: boolean = false;


  public refreshing: boolean;
  public loggedinUser: string = '';
  public tableColumns: any;
  public displayedColumns: any;

  public pageName: string = '';
  public selectedFeedType: string = '';
  public selectedKPIType: string = '';
  public prevPageselected: string = '';

  public isInboundAva: boolean = true;
  public avaTotal: any;
  public avaTotalCur: any;
  public finalAvaTotal: any;
  public avaPercentage: any;


  public contentMsgData: any;
  public displayedData = [];
  public disputeViewData: string = "";
  public disputeViewKpiData: string = "";

  public excelDataList: any;
  public excelDataListPush: any;

  public gridName = "NA";
  public usertype = "NA";

  public headderInfo = "";
  public backButton = "NA";
  public headerGroupName = "";

  public parms: string = "";
  public comm_plan: string = "";
  public grid_name: string = "";
  public actualParms: string = "";
  public searchParms1: string = "";
  public searchParms: string = "";
  public searchEmpParm: string = "";
  public searchKpiIdParm: string = "";

  public searchEmpParmSup: string = "";
  public searchKpiIdParmSup: string = "";
  public searchDependentKpiIdParm1Sup: string = "";
  public searchDependentKpiIdParmSup: string = "";
  public enterpriseManagerPlanBackup: number = 0;
  public enterpriseManagerEmpBackup: string = '';



  public searchDependentKpiIdParm: string = "";
  public searchDependentKpiIdParm1: string = "";

  public searchFromDtParm: string = null;
  public searchToDtParm: string = null;
  public searchSalesRepIdParm: string = "";

  public searchHouseParm: string = "";
  public searchCustParm: string = "";
  public searchCorpParm: string = "";

  public total1: number = 0.00;
  public total2: number = 0.00;
  public total3: number = 0.00;
  public total4: number = 0.00;
  public total5: number = 0.00;

  public showHideTd1: boolean;
  public showHideTd2: boolean;
  public showHideTd3: boolean;
  public showHideTd4: boolean;
  public showHideTd5: boolean;

  public one: string = "0.00";
  public two: string = "0.00";
  public three: string = "0.00";
  public four: string = "0.00";
  public five: string = "0.00";

  public dataKeyVal: string = "";

  public commissionable_units: number = 0;
  public charge_back_units: number = 0;
  public net_units: number = 0;
  public net_revenue: number = 0;
  public commissionable_revenue: number = 0;

  public kpiId: number = 0;
  public dependentkpiId: number = 0;

  public kpiid: any = "";
  public dependent_kpiid: any = "";
  public final_kpiid: any = "";
  public sc_emp_id: any = "";

  public corp: any = "";
  public house: any = "";
  public cust: any = "";
  public kom_feed_id: any;
  public acc_num: any;
  public mobfeedid: any;

  public sql_str: string = "";
  public header_str: string = "";
  public accnum: any;
  public subnum: any;
  public mobkpiid: any;

  public dpndnt_sc_emp_id: string = "";

  public selectedSalesChannel: string = "";
  public selectedCommPlanId: number = 0;
  public selected_CommPlanId: number = 0;
  public selectedCalRunId: string = "";
  public selected_CalRunId: string = "";
  public selected_extra_sc_emp_id: number = 0;
  public selectedextra_sc_emp_id: number = 0;
  public selected_sc_emp_id: string = "";
  public selected_sup_extra_sc_emp_id: number = 0;
  public selected_extra_comm_plan_id: number = 0;
  public selected_sup_sc_emp_id: string = "";
  public selectedsc_emp_id: string = "";
  public jsonid: any[];
  public headersArray: Array<string>;
  public isdisputeview: boolean = false;
  public isDisputeSubmitted: string = "true";

  // public isExcelview: boolean = true;

  public dataForExcel = [];
  public dataForExcelKeys = [];



  public columnsExcelData: any;

  public headersObj = {};
  public sortableColumn: string = "";
  public str1: string = "";
  public str2: string = "";
  public nrSelect: string = "";

  public byUser: string = "";
  public findByEmp: string = "";
  public findByDependentProductTotalScore: string = "";
  public findByProduct: string = "";
  public findBySup: string = "";
  public findByHouseCorpCust: string = "";
  public findKpiByCust: string = "";
  public findHouseCorpCustByKpi: string = "";

  public isFixedDisabled: boolean = true;
  public isMobileDisabled: boolean = false;
  public selectedMIssingDisputeVal: string = "f";

  @ViewChild('table') table: ElementRef;
  @ViewChild('table1') table1: ElementRef;



  ngOnInit(): void {
    this.nrSelect = "f";
    this.loadData();
    // this.initializeExcelHeaders();
  }

  public loadData() {
    console.log("loadData Called");

    this.missingDisputesModel.created_by = "";
    this.missingDisputesModel.created_dt = new Date();
    this.missingModels.push(this.missingDisputesModel);

    this.commSummaryModel = this.commissionSummaryService.commSummaryModel;
    this.selectedSalesChannel = this.commSummaryModel.salesChannel;
    this.searchCriteriaSet = this.commissionSummaryService.searchCriteriaSet;

    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
      this.showCheckBox = false;
      this.commSummaryModel.extra_sc_emp_id = 0;
      this.commSummaryModel.sc_emp_id = localStorage.getItem('CURRENT_SC_EMP_ID_SESSION');

      this.commSummaryModel.sup_extra_sc_emp_id = 1;
      this.commSummaryModel.sup_sc_emp_id = 'NA';
      this.commSummaryModel.extra_comm_plan_id = 0;
    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor") {
      this.showCheckBox = false;
      if (this.commSummaryModel.checkboxstatus === true) {
        this.commSummaryModel.extra_sc_emp_id = 1;
        this.commSummaryModel.sc_emp_id = 'NA';

        this.commSummaryModel.sup_extra_sc_emp_id = 0;
        this.commSummaryModel.sup_sc_emp_id = localStorage.getItem('CURRENT_SC_EMP_ID_SESSION');
        this.commSummaryModel.extra_comm_plan_id = 1;

      } else {
        this.commSummaryModel.extra_sc_emp_id = 0;
        this.commSummaryModel.sc_emp_id = localStorage.getItem('CURRENT_SC_EMP_ID_SESSION');

        this.commSummaryModel.sup_extra_sc_emp_id = 1;
        this.commSummaryModel.sup_sc_emp_id = localStorage.getItem('CURRENT_SC_EMP_ID_SESSION');
        this.commSummaryModel.extra_comm_plan_id = 0;
      }
    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Channel Admin") {
      // Sales Channel Admin: Use Admin-like settings (view all, no supervisor filtering)
      this.showCheckBox = false;
      this.commSummaryModel.extra_sc_emp_id = 1;          // View all employees
      this.commSummaryModel.sc_emp_id = 'NA';             // Not specific employee
      this.commSummaryModel.sup_extra_sc_emp_id = 1;      // View all supervisors
      this.commSummaryModel.sup_sc_emp_id = 'NA';         // Not specific supervisor
      this.commSummaryModel.extra_comm_plan_id = 0;       // Use selected comm plan (like Admin)
    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
      this.showCheckBox = false;
      this.commSummaryModel.extra_sc_emp_id = 1;
      this.commSummaryModel.sc_emp_id = 'NA';

      this.commSummaryModel.sup_extra_sc_emp_id = 1;
      this.commSummaryModel.sup_sc_emp_id = 'NA';
      this.commSummaryModel.extra_comm_plan_id = 0;
    }

    if (this.commSummaryModel.commPlanId) {
      this.selectedCommPlanId = this.commSummaryModel.commPlanId;
    } else {
      this.selectedCommPlanId = 0;
    }

    this.selectedCalRunId = this.commSummaryModel.calRunId;
    this.selectedextra_sc_emp_id = this.commSummaryModel.extra_sc_emp_id;
    this.selectedsc_emp_id = this.commSummaryModel.sc_emp_id;

    if (this.commSummaryModel.sup_sc_emp_id === "NA") {
      this.selected_sup_extra_sc_emp_id = this.commSummaryModel.sup_extra_sc_emp_id;
      this.selected_sup_sc_emp_id = this.commSummaryModel.sup_sc_emp_id;
      this.selected_extra_comm_plan_id = this.commSummaryModel.extra_comm_plan_id;
    } else {
      this.selected_sup_extra_sc_emp_id = this.commSummaryModel.sup_extra_sc_emp_id;
      this.selected_sup_sc_emp_id = this.commSummaryModel.sup_sc_emp_id.slice(0, -2);
      this.selected_extra_comm_plan_id = this.commSummaryModel.extra_comm_plan_id;
    }

    this.searchParms1 = this.selectedCalRunId + "," + this.selected_extra_comm_plan_id + "," + this.selectedCommPlanId + "," + this.selectedextra_sc_emp_id + "," + this.selectedsc_emp_id + "," + localStorage.getItem('validToDt') + "," + this.selected_sup_extra_sc_emp_id + "," + this.selected_sup_sc_emp_id;
    this.searchParms = this.selectedCalRunId + "," + this.selectedCommPlanId;
    this.route.queryParams.subscribe(params => {
      this.pageName = params['page'];
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });


    if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
      if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor") {
        //if (localStorage.getItem('MULTIPLE_PROFILE_STATUS') === "YES") {
        this.showCheckBox = true;
      } else {
        this.showCheckBox = false;
      }
    } else {
      this.showCheckBox = false;
    }


    this.getHeadersAndButtons(this.selectedCommPlanId);

    if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
      this.headderInfo = "User Details";
      this.byUser = this.headderInfo;
    }

    this.getActiveKpis();
  }



  ExportToExcelListKpis(res: any, headers: any) {
    this.excelDataList = null;
    this.excelDataList = JSON.parse(JSON.stringify(res));
    for (let js of this.excelDataList) {
      delete js.isDisputeSubmitted;
      delete js.valid_from_dt;
      delete js.valid_to_dt;
      delete js.effective_date;
      delete js.colorcode;
      delete js.comm_plan_id;
      delete js.kpi_id;
      delete js.mcommission_val;
      delete js.mrevenue;
      delete js.sc_emp_id;
      delete js.tier;
      delete js.view_order;
      delete js.sno;
    }

    this.dataForExcel = [];
    this.dataForExcelKeys = [];
    let reportData = null;


    // Normalize per-cell currency symbol (e.g. "$" -> "J$" for JMD plans) so the exported
    // spreadsheet matches the grid (which applies the same override via dataPropertyGetter).
    // (HOA-8305 follow-up)
    const symbolOverride = this.planCurrencySymbolOverride;
    this.excelDataList.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row).map((v: any) => applyCurrencySymbolOverride(v, symbolOverride)));
      this.dataForExcelKeys.push(Object.keys(row));
    });


    reportData = {
      title: 'ReviewCommissions',
      data: this.dataForExcel,
      headers: this.dataForExcelKeys[0]
    }
    this.ete.exportExcel(reportData);
  }

  private fetchDataByPage() {

    this.isInboundAva = true;

    console.log("fetchDataByPage Called");
    console.log(this.pageName);

    this.findParms();
    this.commissionSummaryService.fetchDataByPage(this.pageName, this.selectedCommPlanId, this.supervisorStatus, this.selectedSalesChannel, localStorage.getItem('validToDt')).subscribe(
      (response: UploadJsonModel[]) => {
        this.gridName = "";
        this.jsonListData = response;


        for (let jsonModel of this.jsonListData) {

          this.gridName = jsonModel.gridName;
          this.usertype = jsonModel.user_type;
          this.runSql(this.gridName, jsonModel.id, this.usertype);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      }
    )
  }

  public runSql(gridName: string, id: number, usertype: string): void {
    console.log("order testing = runSql Called");
    this.backButton = "NA";
    this.isNoDataFound = false;


    if (this.calcStatus === "Running") {
      this.isCalcRunning = true;
      //alert("A commission Calc is running.\nThis data may change after its complete.");
    } else {
      this.isCalcRunning = false;
    }


    this.subscriptions = [];
    if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
      this.actualParms = this.searchParms1 + "," + localStorage.getItem('level') + "," + localStorage.getItem('validToDt') + "," + localStorage.getItem('validToDt');
    } else if (this.pageName === "ListKPIs" || this.pageName === "FindByCustByEmp") {
      this.actualParms = this.actualParms;
    }

    console.log(localStorage.getItem('SESSION_DISPUTE_CLOSE_STATUS'));


    if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
      this.isDisBtnDisabled = false;
    } else {
      if (Number(this.supervisorStatus) >= 20) {
        this.isDisBtnDisabled = false;
      } else {
        if (localStorage.getItem('SESSION_DISPUTE_CLOSE_STATUS') === "valid") {
          this.isDisBtnDisabled = true;
        } else {
          this.isDisBtnDisabled = false;
        }

      }
    }

    console.log(this.isDisBtnDisabled);


    if (this.pageName === "ListKPIs" || this.pageName === "FindKpiByCust") {
      this.isExcelBtnDisabled = true;
    } else {
      this.isExcelBtnDisabled = false;
    }

    console.log(this.pageName);
    console.log(this.actualParms);

    this.subscriptions.push(
      this.commissionSummaryService.runSql(this.actualParms, this.pageName, gridName, this.selectedCommPlanId, this.selectedSalesChannel, usertype, localStorage.getItem('validToDt'))
    );


    forkJoin(this.subscriptions).subscribe(response => {

      //console.log(JSON.stringify(response));
      this.parms = "";

      response.forEach(element => {

        // console.log(element.length);
        // if(element.length > 0){



        if (element.length > 0 && (this.pageName === "ListUsers" || this.pageName === "ByCustomer")) {
          this.comm_plan = element[0].comm_plan;
          this.grid_name = this.gridName;
        }


        // console.log("runsql:"+this.supervisorStatus);
        // console.log("runsql:"+this.selectedFeedType);
        // console.log("runsql:"+this.selectedKPIType);
        // console.log("runsql:"+this.pageName);

        //If below condition is true then change page name to get next page

        if (Number(this.supervisorStatus) >= 20 && this.selectedFeedType === "Custom" && (this.pageName === "FindByDependentProduct" || this.pageName === "FindByDependentProductTotalScore")) {
          this.responseList1 = [];
          this.responseList = [];
          this.actualParms = "";
          if (this.selectedSalesChannel === 'Enterprise') {
            this.pageName = 'FindByProductSup';
          } else {
            this.pageName = 'FindByProduct';
          }

          this.getHeadersAndButtons(this.selectedCommPlanId);

        } else if (element.length === 0 && (this.pageName === "FindByDependentProduct" || this.pageName === "FindByDependentProductTotalScore")) {
          this.responseList1 = [];
          this.responseList = [];
          this.actualParms = "";
          if (this.selectedSalesChannel === 'Enterprise') {
            this.pageName = Number(this.supervisorStatus) >= 20
              ? 'FindByProductSup'
              : 'FindByProductEnterprise';
          } else {
            this.pageName = 'FindByProduct';
          }

          this.getHeadersAndButtons(this.selectedCommPlanId);
          //this.notificationService.sendNotification(NotificationType.ERROR, 'No Records Found');
        } else if (element.length === 0) {
          //console.log("Inside else if: no records found");

          if (this.pageName === "ListKPIs") {
            this.isNoDataFound = false;
          } else {
            this.isNoDataFound = true;
          }

        } else {
          if (element.length > 1) {
            this.totalstatus = 1;
            this.totResData1 = element;
            this.totResData1 = JSON.parse(JSON.stringify(this.totResData1));
          } else {
            this.totalstatus = 2;
            this.totResData2 = element;
            this.totResData2 = JSON.parse(JSON.stringify(this.totResData2));
            //console.log("runsql: 4 ELSE: " + JSON.stringify(this.totResData2));
            this.totResData2.forEach(jsonModel => {
              if (jsonModel.valid_from_dt == undefined) { } else {
                this.searchFromDtParm = jsonModel.valid_from_dt;
                this.searchToDtParm = "," + jsonModel.valid_to_dt;
                this.searchSalesRepIdParm = "," + jsonModel.sales_rep_id;
              }
            });
          }

          this.excelData = element;
          this.finalResponseData = JSON.parse(JSON.stringify(element));

          // Comparing data for disputes view
          if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus" || this.pageName === "FindByProductSup" || this.pageName === "FindByProductMobileLines" || this.pageName === "FindByProductMobileLinesPlus") {

            if (Number(this.supervisorStatus) >= 20) {
              this.isdisputeview = false;
            } else {
              this.isdisputeview = true;
            }

            this.compareDispute = element;

            this.compareDispute.forEach((res, index) => {
              this.dscempid = res.sc_emp_id;
              this.dcorp = res.corp;
              this.dhouse = res.house;
              this.dcust = res.cust;
              this.dkomffeedid = res.kom_feed_id;

              this.dtrackid = this.dkomffeedid;

              this.daccnum = res.account_number;

              if (!this.dtrackid) {
                this.dtrackid = this.daccnum;
              }

              if (!this.dtrackid) {
                this.dtrackid = this.dcorp + '-' + this.dhouse + '-' + this.dcust;
              }


              this.commissionSummaryService.getTrackidCount(this.dtrackid).subscribe(
                (response: WorkFlowMessageModel[]) => {

                  if (response.length > 0) {
                    if (response[0].status === "Rejected") {
                      this.finalResponseData[index].isDisputeSubmitted = "true";
                      this.isDisputeSubmitted = "true";
                    } else {
                      this.finalResponseData[index].isDisputeSubmitted = "false";
                      this.isDisputeSubmitted = "false";
                    }

                  } else {
                    this.finalResponseData[index].isDisputeSubmitted = "true";
                    this.isDisputeSubmitted = "true";
                  }

                }, (errorResponse: HttpErrorResponse) => {
                  var msg: any;
                  msg = errorResponse;
                  this.notificationService.sendNotification(NotificationType.ERROR, msg);
                  this.showLoading = false;
                });


            });

          } else {
            this.isdisputeview = false;
          }
          // console.log("responseList1:" + JSON.stringify(this.finalResponseData));
          const data = new ResponseData();
          if (JSON.stringify(this.finalResponseData).includes("Error")) {
            // console.log("errorrr if");
          } else {
            // console.log("errorrr else");
            const inputDate = new Date(localStorage.getItem('validToDt'));
            const today = new Date("2025-12-31");

            // Remove time portion for accurate date-only comparison
            today.setHours(0, 0, 0, 0);
            inputDate.setHours(0, 0, 0, 0);

            let eDateStat: string = "future";

            if (inputDate > today) {
              //console.log("Future date");
              eDateStat = "future";
            } else if (inputDate < today) {
              //console.log("Past date");
              eDateStat = "past";
            } else {
              //console.log("Same date");
              eDateStat = "same";
            }

            if (this.selectedSalesChannel === "Communities" && this.gridName === "Customer Details Sup" && eDateStat === "future") {
              id = 308;
            }

            data.responsedata = this.finalResponseData;

            this.headersData1 = this.headersData.filter(item => item.jsonsqlid.toString() === id.toString());
            this.buttonsData1 = this.buttonsData.filter(item => item.jsonsqlid.toString() === id.toString());

            data.headers = JSON.parse(JSON.stringify(this.headersData1));
            data.buttons = JSON.parse(JSON.stringify(this.buttonsData1));

            this.responseList1.push(data);
            //console.log("responseList1:"+JSON.stringify(this.responseList1));
            this.responseList1.sort((a, b) => {
              return a.responsedata[0].sno - b.responsedata[0].sno; // Sort by price in ascending order
            });

            if (this.responseList1.length === 1) {
              this.responseList.push(this.responseList1[0]);
              this.totResData1 = JSON.parse(JSON.stringify(element));
            } else {
              this.responseList = [];
              this.responseList = this.responseList1;
            }

            console.log(this.responseList);

            // this.dataService.setData(this.responseList1);

            // if (this.pageName === "ListUsers") {
            //   this.backBtnResponseListUsers = JSON.parse(JSON.stringify(this.responseList1));
            // } else if (this.pageName === "ListKPIs" || this.pageName === "FindByCustByEmp") {
            //   this.backBtnResponseListKpis = JSON.parse(JSON.stringify(this.responseList1));
            // }

            this.totalView = "false";

            if (this.headersData1[0]) {
              this.totalView = this.headersData1[0].istotalview;
            }


            this.findSum(this.totalView);
          }
        }
        // }else{
        //   console.log("No Records Found");
        //  // this.isNoDataFound = true;
        //  // this.notificationService.sendNotification(NotificationType.ERROR, 'No Records Found');
        // }
      });

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
      this.showLoading = false;
    });
  }

  filterData(value: any) {
    this.selectedMIssingDisputeVal = value;
    if (value === "f") {
      this.isFixedDisabled = true;
      this.isMobileDisabled = false;
    } else {
      this.isFixedDisabled = false;
      this.isMobileDisabled = true;
    }
  }



  /** Header hyperlink flag + optional SQL row flag (ishyperlink) — KPI rules live in CommsUI SQL. */
  isRowHyperlinkEnabled(row: any, header: any): boolean {
    const headerEnabled = header?.ishyperlinkview === true
      || header?.ishyperlinkview === 1
      || String(header?.ishyperlinkview).toLowerCase() === 'true';
    return headerEnabled && ReviewCommissionsService.isSqlRowHyperlinkAllowed(row);
  }

  public onClickHyperLink(resData: any, pageNav: string) {
    //console.log("onClickHyperLink() called");
    if (!ReviewCommissionsService.isSqlRowHyperlinkAllowed(resData)) {
      return;
    }
    if (this.pageName === 'ListKPIs') {
      this.listKpisBackupCommPlanId = this.selectedCommPlanId;
      this.listKpisBackupSearchEmpParm = this.searchEmpParm;
      this.listKpisBackupSearchParms = this.searchParms;
    }
    //console.log(JSON.stringify(resData));
    //console.log(resData.dpndnt_sc_emp_id);
    this.dpndnt_sc_emp_id = "," + resData.dpndnt_sc_emp_id;

    //this.comm_plan = resData.comm_plan;

    if (resData.account_number) {
      localStorage.setItem("cust0", ",1");
      localStorage.setItem("house0", ",1");
      localStorage.setItem("corp0", ",1");
      localStorage.setItem("acc0", ",0");
      this.accnum = "," + resData.account_number;
      this.subnum = "," + resData.subscriber_number;
      this.mobkpiid = "," + resData.kpi_id;
      localStorage.setItem("acc1", this.accnum);
    } else {
      localStorage.setItem("cust0", ",0");
      localStorage.setItem("house0", ",0");
      localStorage.setItem("corp0", ",0");
      localStorage.setItem("acc0", ",1");
      this.accnum = ",0";
      localStorage.setItem("acc1", this.accnum);
    }

    this.selectedCommPlanId = resData.comm_plan_id;
    if (this.selectedCommPlanId) {
      this.searchParms = this.selectedCalRunId + "," + this.selectedCommPlanId;
    } else {
      this.selectedCommPlanId = 0;
      this.searchParms = this.selectedCalRunId + "," + this.selectedCommPlanId;
    }

    localStorage.setItem('SESSIONS_dpndnt_kpi_id', resData.dpndnt_kpi_id);

    // Enterprise manager/director only: show rep order breakdown, not Product Details Sup
    if (
      pageNav === 'FindByProductDetailSup' &&
      this.selectedSalesChannel === 'Enterprise' &&
      Number(this.supervisorStatus) >= 20
    ) {
      pageNav = 'FindByProductEnterprise';
    }

    this.pageName = pageNav;
    if (
      pageNav === 'FindByDependentProductTotalScore' &&
      this.selectedSalesChannel === 'Enterprise'
    ) {
      // Do not force supervisorStatus = '20' — keep real status for getPageNames()

      // Different plan than ListKPIs = middle/release grid → keep row plan
      const isOtherPlanRow =
        this.listKpisBackupCommPlanId > 0 &&
        resData.comm_plan_id != null &&
        Number(resData.comm_plan_id) !== this.listKpisBackupCommPlanId;

      if (!isOtherPlanRow && this.listKpisBackupCommPlanId > 0) {
        this.selectedCommPlanId = this.listKpisBackupCommPlanId;
      }
      if (this.enterpriseManagerEmpBackup) {
        this.searchEmpParmSup = this.enterpriseManagerEmpBackup;
      }
      if (this.searchKpiIdParmSup) {
        this.searchKpiIdParm = this.searchKpiIdParmSup;
        this.searchDependentKpiIdParm1 = this.searchDependentKpiIdParm1Sup || ',1';
        this.searchDependentKpiIdParm = this.searchDependentKpiIdParmSup || ',0';
      }
    }
    if (this.pageName === "FindKpiByCust") {
      if (resData.kom_feed_id) {
        localStorage.setItem("bycust_feed", "kom");
      } else {
        localStorage.setItem("bycust_feed", "mob");
        localStorage.setItem("acc2", this.accnum);
        localStorage.setItem("subno2", this.subnum);
        localStorage.setItem("kpiid2", this.mobkpiid);
      }
    }

    if (this.pageName === "FindHouseCorpCustByKpi") {

      if (localStorage.getItem("bycust_feed") === "kom") {
        this.pageName = "FindHouseCorpCustByKpi";
      } else {
        this.pageName = "FindMobileLinesByKpi";
      }

    }

    // HEADER INFO - FORWARD
    console.log("Header Info :" + this.pageName);
    console.log("Header Info My Teams Checked: " + this.checkedactive);



    if (this.pageName === "ListKPIs" || this.pageName === "FindByCustByEmp") {
      this.headderInfo = this.headderInfo + " -> " + resData.empname;
      this.findByEmp = this.headderInfo;
    } else if (this.pageName === "FindByDependentProductTotalScore") {
      this.headderInfo = this.headderInfo + " -> " + resData.kpiname;
      this.findByDependentProductTotalScore = this.headderInfo;
    } else if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus" || this.pageName === "FindByProductSup") {
      this.headderInfo = this.headderInfo + " -> " + resData.display_name;
      this.findByProduct = this.headderInfo;
    } else if (this.pageName === "FindByProductDetailSup") {
      this.headderInfo = this.headderInfo + " -> " + resData.cust_name;
      this.findBySup = this.headderInfo;
    } else if (
      this.pageName === 'FindByProductEnterprise' &&
      this.selectedSalesChannel === 'Enterprise' &&
      Number(this.supervisorStatus) >= 20 &&
      resData.cust_name
    ) {
      this.headderInfo = this.headderInfo + ' -> ' + resData.cust_name;
      this.findBySup = this.headderInfo;
    } else if (this.pageName === "FindByHouseCorpCust") {
      this.headderInfo = this.headderInfo + " -> " + resData.house;
      this.findByHouseCorpCust = this.headderInfo;
    } else if (this.pageName === "FindKpiByCust") {
      this.headderInfo = this.headderInfo + " -> " + resData.cust_name;
      this.findKpiByCust = this.headderInfo;
    } else if (this.pageName === "FindHouseCorpCustByKpi") {
      this.headderInfo = this.headderInfo + " -> " + resData.kpiname;
      this.findHouseCorpCustByKpi = this.headderInfo;
    } else if (this.pageName === "FindMobileLinesByKpi") {
      this.headderInfo = this.headderInfo + " -> " + resData.kpiname;
      this.findHouseCorpCustByKpi = this.headderInfo;
    }

    console.log("Header Info :" + this.headderInfo);

    this.searchEmpParm = resData.sc_emp_id;
    if (this.searchEmpParm !== undefined) {
      localStorage.setItem("emp", this.searchEmpParm);
    }
    this.searchKpiIdParm = "," + resData.kpi_id;
    if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus") {
      this.searchDependentKpiIdParm1 = "," + "0";
      this.searchDependentKpiIdParm = "," + resData.dpndnt_kpi_id;
    } else {
      this.searchDependentKpiIdParm1 = "," + "1";
      this.searchDependentKpiIdParm = "," + "0";
    }
    // Enterprise manager/director only: use rep emp id + rep comm plan (not manager plan 99)
    const isEnterpriseManagerRepDrill =
      this.pageName === 'FindByProductEnterprise' &&
      this.selectedSalesChannel === 'Enterprise' &&
      Number(this.supervisorStatus) >= 20;

    if (isEnterpriseManagerRepDrill) {
      this.enterpriseManagerPlanBackup = this.selectedCommPlanId;
      this.enterpriseManagerEmpBackup = this.searchEmpParmSup;

      this.searchEmpParm = resData.dpndnt_sc_emp_id;
      this.searchKpiIdParm = this.searchKpiIdParmSup;
      this.searchDependentKpiIdParm1 = this.searchDependentKpiIdParm1Sup;
      this.searchDependentKpiIdParm = this.searchDependentKpiIdParmSup;
      if (this.searchEmpParm !== undefined) {
        localStorage.setItem('emp', this.searchEmpParm);
      }
    }

    if (resData.house) {
      this.searchCustParm = "," + resData.cust;
      localStorage.setItem("cust0", ",0");
      localStorage.setItem("cust1", this.searchCustParm);
      this.searchHouseParm = "," + resData.house;
      localStorage.setItem("house0", ",0");
      localStorage.setItem("house1", this.searchHouseParm);
      this.searchCorpParm = "," + resData.corp;
      localStorage.setItem("corp0", ",0");
      localStorage.setItem("corp1", this.searchCorpParm);
      localStorage.setItem("acc0", ",1");
      localStorage.setItem("acc1", ",0");
    } else {
      // console.log("Inside ELSE corp house cust");
    }

    this.kpiId = 0;
    this.dependentkpiId = 0;

    this.kpiId = resData.kpi_id;
    this.dependentkpiId = resData.dpndnt_kpi_id;


    const loadPageData = () => {
      if (this.pageName === 'FindMobileLinesByKpi') {
        this.getHeadersAndButtons(this.selectedCommPlanId);
      } else if (
        this.selectedSalesChannel === 'Enterprise' &&
        Number(this.supervisorStatus) < 20 &&
        (this.pageName === 'FindByDependentProductTotalScore' ||
          this.pageName === 'FindByProductEnterprise')
      ) {
        // Rep only — keep page; do not call getPageNames (managers need getPageNames → FindByProductSup)
        this.getHeadersAndButtons(this.selectedCommPlanId);
      } else if (this.dependentkpiId) {
        this.getPageNames(this.dependentkpiId);
      } else if (this.kpiId) {
        this.getPageNames(this.kpiId);
      } else {
        this.getHeadersAndButtons(this.selectedCommPlanId);
      }
    };

    if (isEnterpriseManagerRepDrill && resData.dpndnt_sc_emp_id) {
      const empId = resData.dpndnt_sc_emp_id.split('_')[0];

      this.commissionSummaryService.getUserDropDownsData(empId).subscribe(
        (plans) => {
          if (this.pageName !== 'FindByProductEnterprise') {
            return;
          }

          const repPlan = plans.find(
            (p) =>
              p.salesChannel === 'Enterprise' &&
              p.calRunId === this.selectedCalRunId
          );

          if (repPlan) {
            this.selectedCommPlanId = repPlan.commPlanId;
            this.searchParms = this.selectedCalRunId + ',' + this.selectedCommPlanId;
          }

          loadPageData();
        },
        (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
          this.showLoading = false;
        }
      );
    } else {
      loadPageData();
    }


  }

  getPageNames(kpiid: number) {
    console.log("getPageNames() Called");
    this.pageNameList = [];
    this.commissionSummaryService.getPageName(this.selectedCommPlanId, kpiid).subscribe(
      (response: UploadJsonHeadersModel[]) => {
        this.pageNameList = response;

        // console.log(JSON.stringify(this.pageNameList));

        this.selectedFeedType = this.pageNameList[0].pageName;
        this.selectedKPIType = this.pageNameList[0].kpi_type;

        // console.log("Inside "+this.supervisorStatus);
        console.log("Inside " + this.selectedFeedType);

        if (this.selectedFeedType === "No Page") {
          this.notificationService.sendNotification(NotificationType.WARNING, 'No Drill Downs Allocated');
          return;
        } else {

          this.responseList1 = [];
          this.responseList = [];

          if (this.selectedFeedType === "KOM Feed" && this.pageNameList[0].kpi_type === "By KPI" && kpiid.toString() === "57") {
            // console.log("Inside 1");
            this.pageName = "FindByDependentProduct";
          } else if (this.selectedFeedType === "Mobile" && this.pageNameList[0].kpi_type === "By KPI") {
            // console.log("Inside 2");
            if (this.pageName === "FindByProductDepnt") {
              //console.log("Inside 3");
              this.pageName = "FindByProductMobileLines";
            } else if (this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus") {
              // console.log("Inside 4");
              if (Number(this.supervisorStatus) >= 20) {
                console.log(this.selectedSalesChannel);
                this.pageName = "FindByProductSup";
              } else {
                this.pageName = "FindByProductMobileLines";
              }
            } else {
              // console.log("Inside 5");
              this.pageName = "FindByDependentProductTotalScore";
            }

          } else if (this.selectedFeedType === "Mobile" && this.pageNameList[0].kpi_type === "NA") {
            // console.log("Inside 6");
            this.pageName = "FindByProductMobileLines";
          } else if (this.selectedFeedType === "Call Details" && this.pageNameList[0].kpi_type === "NA") {
            console.log("CallDetails");
            this.pageName = "FindByProductCallDetails";
          } else if (this.selectedFeedType === "AVA" && this.pageNameList[0].kpi_type === "NA") {
            console.log("CallDetails");
            this.pageName = "FindByProductAVA";
          } else if (this.selectedFeedType === "CAM Feed" && this.pageNameList[0].kpi_type === "NA") {
            console.log("CAM Feed");
            this.pageName = "FindByProductCamFeed";
          } else if (this.selectedFeedType === "Survey Store Ratings" && this.pageNameList[0].kpi_type === "NA") {
            console.log("Survey Store Ratings");
            this.pageName = "FindByProductRetail";
          } else if (this.selectedFeedType === "ENT Feed" && (this.pageNameList[0].kpi_type === "NA" || this.pageNameList[0].kpi_type === "By KPI")) {
            console.log("ENT Feed");
            if (Number(this.supervisorStatus) >= 20) {
              this.pageName = 'FindByProductSup';
            } else {
              this.pageName = 'FindByProductEnterprise';
            }
          } else if (this.selectedFeedType === "Mobile 2 Plus" && this.pageNameList[0].kpi_type === "NA") {
            console.log("Mobile 2 Plus");
            this.pageName = "FindByProductMobileLinesPlus";
          } else if (this.selectedFeedType === "ENT Feed" && this.pageNameList[0].kpi_type === "By KPI" && kpiid.toString() === "282" && this.pageName === "FindByProductDepntTotal") {
            // console.log("Inside 1");
            this.pageName = "FindByProductEnterprise";
          } else if (this.selectedFeedType === "ENT Feed" && this.pageNameList[0].kpi_type === "By KPI" && kpiid.toString() === "291" && this.pageName === "FindByProductDepntTotal") {
            // console.log("Inside 1");
            this.pageName = "FindByProductEnterprise";
          } else if (this.selectedFeedType === "CAM Feed Data Adds") {
            console.log("CAM Feed Data Adds");
            this.pageName = "FindByProductCamFeedDataAdds";
          } else if (this.selectedFeedType === "CAM Feed Data Disc") {
            console.log("CAM Feed Data Disc");
            this.pageName = "FindByProductCamFeedDataDisc";
          } else if (this.selectedFeedType === "CAM Feed Video Adds") {
            console.log("CAM Feed Video Adds");
            this.pageName = "FindByProductCamFeedVideoAdds";
          } else if (this.selectedFeedType === "CAM Feed Video Disc") {
            console.log("CAM Feed Video Disc");
            this.pageName = "FindByProductCamFeedVideoDisc";
          } else if (this.selectedFeedType === "CAM Feed Mob Add") {
            console.log("CAM Feedd Mob Add");
            this.pageName = "FindByProductCamFeedMobileAdd";
          } else if (this.selectedFeedType === "CAM Feed Mob Disc") {
            console.log("CAM Feedd Mob Disc");
            this.pageName = "FindByProductCamFeedMobileDisc";
          } else if (this.selectedFeedType === "ENT Adj" || this.selectedFeedType === "ADJ INC") {
            console.log("ENT ADJ/ ADJ INC");
            this.pageName = "FindByProductEntAdj";
          } else if (this.selectedFeedType === "Fixed and Mobile") {
            console.log("Fixed and Mobile");
            this.pageName = "FindByProductDepntTotalPlus";
          }

          // ByPass for Sup Plans — do not override Enterprise ENT Feed pages
          if (
            Number(this.supervisorStatus) >= 20 &&
            this.selectedSalesChannel !== 'Enterprise' &&
            this.selectedFeedType !== 'ENT Feed' &&
            this.selectedFeedType !== 'ENT Adj' &&
            this.selectedFeedType !== 'ADJ INC'
          ) {
            console.log(this.selectedSalesChannel);
            this.pageName = "FindByProductSup";
          }

          this.getHeadersAndButtons(this.selectedCommPlanId);
        }

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      });
  }

  getHeadersAndButtons(complanid: number) {
    console.log("getHeadersAndButtons Called");

    if (this.selectedFeedType !== "No Page") {
      this.responseList1 = [];
      this.responseList = [];
    }
    this.getSupervisorStatus(complanid);
  }

  getSupervisorStatus(complanid: number) {
    console.log("getSupervisorStatus() called");
    this.commissionSummaryService.getSupervisorStatus(complanid).subscribe(
      (response: UploadJsonHeadersModel[]) => {
        this.supStatus = response;
        // console.log(JSON.stringify(this.supStatus));
        if (this.supStatus.length > 0) {
          this.supervisorStatus = this.supStatus[0].status;
        } else {
          this.supervisorStatus = "NA";
        }



        if (Number(this.supervisorStatus) >= 20 && (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus" || this.pageName === "FindByProductMobileLines" || this.pageName === "FindByProductMobileLinesPlus")) {
          this.pageName = "FindByProductSup";
        }

        this.getRequiredData(complanid, this.selectedCalRunId);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      });
  }

  getRequiredData(complanid: number, calrunid: string) {
    console.log("getRequiredData() Called");
    //localStorage.getItem('validToDt')
    this.commissionSummaryService.getHeaders(complanid, this.selectedSalesChannel, this.supervisorStatus, localStorage.getItem('validToDt')).subscribe(
      (response: UploadJsonHeadersModel[]) => {
        this.headersData = response;
        this.headersData1 = JSON.parse(JSON.stringify(response));
        this.commissionSummaryService.fetchButtons(complanid).subscribe(
          (response: UploadJsonHeadersModel[]) => {
            this.buttonsData = response;
            this.buttonsData1 = JSON.parse(JSON.stringify(response));

            if (complanid !== 0) {
              this.commissionSummaryService.getCalcRunningStatus(complanid, calrunid).subscribe(
                (response: UploadJsonHeadersModel[]) => {
                  this.calcRunningStatus = response;
                  if (this.calcRunningStatus.length > 0) {
                    this.calcStatus = this.calcRunningStatus[0].status;
                  } else {
                    this.calcStatus = "NA";
                  }

                  this.fetchDataByPage();

                }, (errorResponse: HttpErrorResponse) => {
                  var msg: any;
                  msg = errorResponse;
                  this.notificationService.sendNotification(NotificationType.ERROR, msg);
                  this.showLoading = false;
                });
            } else {
              console.log("Complan ID is zero");
            }
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
            this.showLoading = false;
          });
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      });
  }

  // Currency symbol override (e.g. "J$" for JMD) for the current plan, or undefined for USD.
  // Same source as formatTotalsCurrency, so per-row money cells match the totals row. Used by
  // the template to normalize per-row "$" cells for Jamaica-country plans. (HOA-8305 follow-up)
  get planCurrencySymbolOverride(): string | undefined {
    return getCurrencyInfo(localStorage.getItem('country'), localStorage.getItem('sc')).symbolOverride;
  }

  // HOA-8305: format a totals value as plan currency. When the plan currency is JMD the symbol
  // is shown as "J$" and the space Intl inserts is stripped (matching the previous per-branch
  // formatting). Currency is driven by plan country, falling back to the legacy sales channel.
  private formatTotalsCurrency(value: number): string {
    const info = getCurrencyInfo(localStorage.getItem('country'), localStorage.getItem('sc'));
    const formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: info.code }).format(value);
    return info.symbolOverride
      ? formatted.replace(info.code, info.symbolOverride).replace(/\s/g, '')
      : formatted;
  }

  findSum(toalView: any) {
    //console.log("findSum Called");
    let currencySymbol = getCurrencyInfo(localStorage.getItem('country'), localStorage.getItem('sc')).code;

    this.total1 = 0.00;
    this.total2 = 0.00;
    this.total3 = 0.00;
    this.total4 = 0.00;
    this.total5 = 0.00;

    this.totResData = this.totResData1;

    if (this.pageName === "ListKPIs" || this.pageName === "FindKpiByCust") {
      if (this.totResData[0].kpi_id) {
      } else {
        this.totResData = this.totResData2;
      }
    }

    for (let j = 0; j < this.totResData.length; j++) {

      if (this.totResData[j].kpiname === "Adjustments") {
        this.adjustmentCommValue = this.totResData[j].commission_val;
      }

      if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
        this.showHideTd1 = false;
        this.showHideTd2 = true;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].commission_val;
        this.one = this.formatTotalsCurrency(this.total1);

      } else if (this.pageName === "ListKPIs") {
        this.showHideTd1 = false;
        this.showHideTd2 = true;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        if (toalView === "true") {

          if (this.totResData[j].commission_val == undefined || this.totResData[j].commission_val == null || this.totResData[j].commission_val == "null") {
          } else {
            this.total1 += +this.totResData[j].commission_val;
          }

          this.one = this.formatTotalsCurrency(this.total1);

          if (localStorage.getItem('sc') === "Inbound" && (this.totResData[j].kpiname === "AVA Compliance Target" || this.totResData[j].kpiname === "Ava Compliance Target")) {
            this.isInboundAva = false;
            this.avaPercentage = this.totResData[j].percentage;

            if (this.totResData[j].percentage >= 100) {
              //console.log("AVA== Inside IF2");
              this.avaPercentage = 0;
              this.avaTotalCur = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(0.00);
            }
          }

          if (localStorage.getItem('sc') === "Inbound") {
            // console.log("AVATOT1 :" + this.total1);
            // console.log("adjustmentCommValue2 = "+this.adjustmentCommValue);

            this.avaTotalCur = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format((this.avaPercentage / 100) * (this.total1 - this.adjustmentCommValue));
            this.avaTotal = (this.avaPercentage / 100) * (this.total1 - this.adjustmentCommValue);
            // console.log("AVATOT2 :" + this.avaTotal);
            this.finalAvaTotal = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1 - this.avaTotal);
          }



        }

      } else if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus") {
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = false;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].commissionable_units;
        this.total3 += +this.totResData[j].net_revenue;
        this.total4 += +this.totResData[j].commission;

        this.one = this.total1.toString();
        this.two = this.total2.toString();

        this.three = this.formatTotalsCurrency(this.total3);
        this.four = this.formatTotalsCurrency(this.total4);


      } else if (this.pageName === "FindByProductSup") {

        // console.log(this.selectedSalesChannel);
        // console.log(this.gridName);
        // console.log(localStorage.getItem('validToDt'));

        const inputDate = new Date(localStorage.getItem('validToDt'));
        const today = new Date("2025-12-31");

        // Remove time portion for accurate date-only comparison
        today.setHours(0, 0, 0, 0);
        inputDate.setHours(0, 0, 0, 0);

        let eDateStat: string = "future";

        if (inputDate > today) {
          // console.log("Future date");
          eDateStat = "future";
        } else if (inputDate < today) {
          //console.log("Past date");
          eDateStat = "past";
        } else {
          // console.log("Same date");
          eDateStat = "same";
        }

        // console.log(eDateStat);

        if (this.selectedSalesChannel === "Communities" && this.gridName === "Customer Details Sup" && eDateStat === "future") {
          this.showHideTd1 = false;
          this.showHideTd2 = false;
          this.showHideTd3 = true;
          this.showHideTd4 = true;
          this.showHideTd5 = true;
          this.total1 += +this.totResData[j].commissionable_units;
          this.total2 += +this.totResData[j].points;
          this.total3 += +this.totResData[j].net_revenue;

          if (Number(this.supervisorStatus) >= 20 && (this.kpiId == 126 || this.kpiId == 127)) {
            this.one = this.total1.toString();
            //this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1);
          } else if (Number(this.supervisorStatus) >= 20) {
            this.one = this.total1.toString();
            //this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1);
          } else {
            this.one = this.total1.toString();
          }

          if (Number(this.supervisorStatus) >= 20 && (this.kpiId == 126 || this.kpiId == 127)) {
            this.two = this.total2.toString();
            //this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1);
          } else if (Number(this.supervisorStatus) >= 20) {
            this.two = this.total2.toFixed(2);
            //this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1);
          } else {
            this.two = this.total2.toString();
          }


          this.three = this.formatTotalsCurrency(this.total3);
        } else {
          this.showHideTd1 = false;
          this.showHideTd2 = false;
          this.showHideTd3 = true;
          this.showHideTd4 = true;
          this.showHideTd5 = true;
          this.total1 += +this.totResData[j].commissionable_units;
          this.total2 += +this.totResData[j].net_revenue;

          if (Number(this.supervisorStatus) >= 20 && (this.kpiId == 126 || this.kpiId == 127)) {
            this.one = this.total1.toString();
            //this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1);
          } else if (Number(this.supervisorStatus) >= 20) {
            this.one = this.total1.toString();
            //this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1);
          } else {
            this.one = this.total1.toString();
          }


          this.two = this.formatTotalsCurrency(this.total2);
        }




      } else if (this.pageName === "FindByProductDetailSup") {
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].net_revenue;




        this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1);

        this.two = this.formatTotalsCurrency(this.total2);


      } else if (this.pageName === "FindByProductMobileLines" || this.pageName === "FindByProductMobileLinesPlus") {
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].net_revenue;
        this.total3 += +this.totResData[j].commissionable_revenue;
        this.one = this.total1.toString();

        this.two = this.formatTotalsCurrency(this.total2);
        this.three = this.formatTotalsCurrency(this.total3);

      } else if (this.pageName === "FindByProductCamFeed") {
        console.log(this.pageName);
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].total_active_subs_recurring_revenue;
        this.total2 += +this.totResData[j].commissionable_units;
        this.total3 += +this.totResData[j].commission;

        this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total1);
        this.two = this.total2.toString();
        this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total3);


      } else if (this.pageName === "FindByProductCamFeedDataAdds") {
        console.log(this.pageName);
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = false;
        this.showHideTd5 = false;

        this.total1 += +this.totResData[j].data_add_acq_ind;
        this.total2 += +this.totResData[j].data_psu_upgrades;
        this.total3 += +this.totResData[j].total_active_subs_recurring_revenue;
        this.total4 += +this.totResData[j].commissionable_units;
        this.total5 += +this.totResData[j].commission;

        this.one = this.total1.toString();
        this.two = this.total2.toString();
        this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total3);
        this.four = this.total4.toString();
        this.five = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total5);


      } else if (this.pageName === "FindByProductCamFeedDataDisc") {
        console.log(this.pageName);
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = false;
        this.showHideTd5 = false;

        this.total1 += +this.totResData[j].data_disconnect_ind;
        this.total2 += +this.totResData[j].data_psu_downgrades;
        this.total3 += +this.totResData[j].total_active_subs_recurring_revenue;
        this.total4 += +this.totResData[j].commissionable_units;
        this.total5 += +this.totResData[j].commission;

        this.one = this.total1.toString();
        this.two = this.total2.toString();
        this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total3);
        this.four = this.total4.toString();
        this.five = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total5);


      } else if (this.pageName === "FindByProductCamFeedVideoAdds") {
        console.log(this.pageName);
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = false;
        this.showHideTd5 = false;

        this.total1 += +this.totResData[j].video_add_acq_ind;
        this.total2 += +this.totResData[j].video_psu_upgrades;
        this.total3 += +this.totResData[j].total_active_subs_recurring_revenue;
        this.total4 += +this.totResData[j].commissionable_units;
        this.total5 += +this.totResData[j].commission;

        this.one = this.total1.toString();
        this.two = this.total2.toString();
        this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total3);
        this.four = this.total4.toString();
        this.five = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total5);


      } else if (this.pageName === "FindByProductCamFeedVideoDisc") {
        console.log(this.pageName);
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = false;
        this.showHideTd5 = false;

        this.total1 += +this.totResData[j].video_disconnect_ind;
        this.total2 += +this.totResData[j].video_psu_downgrades;
        this.total3 += +this.totResData[j].total_active_subs_recurring_revenue;
        this.total4 += +this.totResData[j].commissionable_units;
        this.total5 += +this.totResData[j].commission;

        this.one = this.total1.toString();
        this.two = this.total2.toString();
        this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total3);
        this.four = this.total4.toString();
        this.five = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total5);


      } else if (this.pageName === "FindByProductCamFeedMobileAdd") {
        console.log(this.pageName);
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].gross_mobile_connect_cnt;
        this.total2 += +this.totResData[j].commissionable_units;
        this.total3 += +this.totResData[j].commission;

        this.one = this.total1.toString();
        this.two = this.total2.toString();
        this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total3);

      } else if (this.pageName === "FindByProductCamFeedMobileDisc") {
        console.log(this.pageName);
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].gross_mobile_disconnect_cnt;
        this.total2 += +this.totResData[j].commissionable_units;
        this.total3 += +this.totResData[j].commission;

        this.one = this.total1.toString();
        this.two = this.total2.toString();
        this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total3);

      } else if (this.pageName === "FindByProductEnterprise") {
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].commissionable_revenue;
        this.total3 += +this.totResData[j].commission;

        this.one = this.total1.toString();
        this.two = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total2);
        this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: currencySymbol }).format(this.total3);


      } else if (this.pageName === "FindByCustByEmp") {
        this.showHideTd1 = false;
        this.showHideTd2 = true;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commission;

        this.one = this.formatTotalsCurrency(this.total1);

      } else if (this.pageName === "FindKpiByCust") {
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].commission_val;
        this.one = this.total1.toString();

        this.two = this.formatTotalsCurrency(this.total2);

      } else if (this.pageName === "FindByDependentProduct") {
        this.showHideTd1 = false;
        this.showHideTd2 = true;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].score_intermediate;
        this.one = Number(this.total1).toFixed(2);
      } else if (this.pageName === "FindByDependentProductTotalScore") {
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].revenue;
        this.one = this.total1.toString();

        this.two = this.formatTotalsCurrency(this.total2);

      }
    }// for close

  }

  findParms() {
    console.log("findParms() Called");
    console.log(this.pageName);
    this.actualParms = "";
    if (this.pageName === "ListUsers") {
      console.log("Inside ListUsers");
      this.actualParms = this.searchParms1 + "," + localStorage.getItem('level') + "," + localStorage.getItem('validToDt') + "," + localStorage.getItem('validToDt');
      console.log("Inside ListUsers: " + this.actualParms);
    } else if (this.pageName === "ByCustomer") {
      this.actualParms = this.searchParms1 + "," + localStorage.getItem('level') + "," + localStorage.getItem('validToDt') + "," + localStorage.getItem('validToDt');
    } else if (this.pageName === "ListKPIs") {
      this.actualParms = this.searchEmpParm + "," + this.searchParms + "," + localStorage.getItem('validToDt') + "," + localStorage.getItem('validToDt') + "," + localStorage.getItem('validToDt');
    } else if (this.pageName === "FindByDependentProduct") {
      this.actualParms = this.selectedCalRunId + "," + this.searchEmpParm + this.searchKpiIdParm + "," + this.selectedCommPlanId + "," + localStorage.getItem('validToDt');
    } else if (this.pageName === "FindByDependentProductTotalScore") {
      this.actualParms = localStorage.getItem('validToDt') + "," + this.selectedCalRunId + "," + this.searchEmpParm + this.searchKpiIdParm + "," + this.selectedCommPlanId;
    } else if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus" || this.pageName === "FindByProductMobileLines" || this.pageName === "FindByProductMobileLinesPlus" || this.pageName === "FindByProductCallDetails" || this.pageName === "FindByProductAVA" || this.pageName === "FindByProductCamFeed" || this.pageName === "FindByProductCamFeedDataAdds" || this.pageName === "FindByProductCamFeedDataDisc" || this.pageName === "FindByProductCamFeedVideoAdds" || this.pageName === "FindByProductCamFeedVideoDisc" || this.pageName === "FindByProductCamFeedMobileAdd" || this.pageName === "FindByProductCamFeedMobileDisc" || this.pageName === "FindByProductRetail" || this.pageName === "FindByProductEnterprise" || this.pageName === "FindByProductSup" || this.pageName === "FindByProductEntAdj") {
      if ((this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus" || this.pageName === "FindByProductSup") && this.backButton === "backbtn") {
        if (this.selectedSalesChannel === 'Enterprise' && this.enterpriseManagerEmpBackup) {
          this.searchEmpParm = this.enterpriseManagerEmpBackup;
          this.searchEmpParmSup = this.enterpriseManagerEmpBackup;
          this.searchKpiIdParm = this.searchKpiIdParmSup;
          this.searchDependentKpiIdParm1 = this.searchDependentKpiIdParm1Sup || ",1";
          this.searchDependentKpiIdParm = this.searchDependentKpiIdParmSup || ",0";
        } else if (localStorage.getItem('SESSIONS_dpndnt_kpi_id') === "null") {
          this.searchDependentKpiIdParm1 = "," + "1";
          this.searchDependentKpiIdParm = "," + "0";
        } else {
          this.searchDependentKpiIdParm1 = "," + "0";
          this.searchDependentKpiIdParm = "," + localStorage.getItem('SESSIONS_dpndnt_kpi_id');
        }
      }

      if (!this.searchEmpParm) {
        this.searchEmpParm = this.searchEmpParmSup;
        this.searchKpiIdParm = this.searchKpiIdParmSup;
        this.searchDependentKpiIdParm1 = this.searchDependentKpiIdParm1Sup;
        this.searchDependentKpiIdParm = this.searchDependentKpiIdParmSup;
      }

      this.searchEmpParmSup = this.searchEmpParm;
      this.searchKpiIdParmSup = this.searchKpiIdParm;
      this.searchDependentKpiIdParm1Sup = this.searchDependentKpiIdParm1;
      this.searchDependentKpiIdParmSup = this.searchDependentKpiIdParm;



      this.actualParms = this.selectedCommPlanId + "," + this.selectedCalRunId + "," + this.searchEmpParm + this.searchKpiIdParm + this.searchDependentKpiIdParm1 + this.searchDependentKpiIdParm;

      if (this.pageName === "FindByProductMobileLines" || this.pageName === "FindByProductMobileLinesPlus" || this.pageName === "FindByProductCamFeed" || this.pageName === "FindByProductCamFeedDataAdds" || this.pageName === "FindByProductCamFeedDataDisc" || this.pageName === "FindByProductCamFeedVideoAdds" || this.pageName === "FindByProductCamFeedVideoDisc" || this.pageName === "FindByProductCamFeedMobileAdd" || this.pageName === "FindByProductCamFeedMobileDisc") {
        console.log("Inside mobile lines");
        this.actualParms = localStorage.getItem('validToDt') + "," + this.selectedCommPlanId + "," + this.selectedCalRunId + "," + this.searchEmpParm + this.searchKpiIdParm + this.searchDependentKpiIdParm1 + this.searchDependentKpiIdParm;
      }
      if (this.pageName === "FindByProductEntAdj") {
        console.log("Inside FindByProductEntAdj");
        this.actualParms = this.selectedCommPlanId + "," + this.selectedCalRunId + "," + this.searchEmpParm + this.searchKpiIdParm;
      }


    } else if (this.pageName === "FindByProductDetailSup") {
      if ((this.pageName === "FindByProductDetailSup") && this.backButton === "backbtn") {
        if (localStorage.getItem('SESSIONS_dpndnt_kpi_id') === "null") {
          this.searchDependentKpiIdParm1 = "," + "1";
          this.searchDependentKpiIdParm = "," + "0";
        } else {
          this.searchDependentKpiIdParm1 = "," + "0";
          this.searchDependentKpiIdParm = "," + localStorage.getItem('SESSIONS_dpndnt_kpi_id');
        }
      }
      this.actualParms = this.selectedCommPlanId + "," + this.selectedCalRunId + "," + this.searchEmpParmSup + this.searchKpiIdParmSup + this.searchDependentKpiIdParm1 + this.searchDependentKpiIdParm + this.dpndnt_sc_emp_id;
    } else if (this.pageName === "FindByHouseCorpCust") {
      this.actualParms = this.searchFromDtParm + this.searchToDtParm + this.searchCustParm + this.searchHouseParm + this.searchCorpParm + this.searchSalesRepIdParm;
    } else if (this.pageName === "FindByCustByEmp") {
      this.actualParms = this.searchParms + "," + localStorage.getItem("emp") + "," + localStorage.getItem('validToDt');
    } else if (this.pageName === "FindKpiByCust") {
      localStorage.setItem("parms", this.searchParms);
      this.actualParms = localStorage.getItem("emp") + "," + localStorage.getItem("parms") + localStorage.getItem("house0") + localStorage.getItem("house1") + localStorage.getItem("corp0") + localStorage.getItem("corp1") + localStorage.getItem("cust0") + localStorage.getItem("cust1") + localStorage.getItem("acc0") + localStorage.getItem("acc1") + "," + localStorage.getItem('validToDt');
      localStorage.setItem("house", this.searchHouseParm);
      localStorage.setItem("corp", this.searchCorpParm);
      localStorage.setItem("cust", this.searchCustParm);
    } else if (this.pageName === "FindHouseCorpCustByKpi") {
      this.actualParms = this.selectedCommPlanId + "," + this.selectedCalRunId + this.searchKpiIdParm + "," + this.searchFromDtParm + this.searchToDtParm + localStorage.getItem("cust") + localStorage.getItem("house") + localStorage.getItem("corp") + this.searchSalesRepIdParm;
    } else if (this.pageName === "FindMobileLinesByKpi") {
      this.actualParms = this.selectedCommPlanId + "," + this.selectedCalRunId + this.searchKpiIdParm + localStorage.getItem("acc2") + localStorage.getItem("subno2") + this.searchSalesRepIdParm;
    } else {
      this.actualParms = this.searchParms;
    }
  }

  public backBtnPage(backPageName: string, backBtn: string) {
    console.log("backBtnPage() Called");

    console.log(backPageName);
    console.log(backBtn);

    if (
      this.pageName === 'FindByProductEnterprise' &&
      this.selectedSalesChannel === 'Enterprise'
    ) {
      if (this.enterpriseManagerPlanBackup > 0) {
        this.selectedCommPlanId = this.enterpriseManagerPlanBackup;
      } else if (this.listKpisBackupCommPlanId > 0) {
        this.selectedCommPlanId = this.listKpisBackupCommPlanId;
      }

      if (this.enterpriseManagerEmpBackup) {
        this.searchEmpParm = this.enterpriseManagerEmpBackup;
        this.searchEmpParmSup = this.enterpriseManagerEmpBackup;
      }

      this.searchParms = this.selectedCalRunId + ',' + this.selectedCommPlanId;

      if (this.enterpriseManagerPlanBackup > 0) {
        // Rep drill set supervisorStatus to 5 — restore manager/director for ListKPIs
        if (Number(this.supervisorStatus) < 20) {
          this.supervisorStatus = '20';
        }
        if (backPageName !== 'ListKPIs') {
          backPageName = 'FindByProductSup';
        }
      }
    }

    this.backButton = backBtn;

    this.headderInfo = "";
    if (this.pageName === "ListKPIs" || this.pageName === "FindByCustByEmp") {
      this.headderInfo = this.byUser;
    } else if (this.pageName === "FindByDependentProductTotalScore" || this.pageName === "FindByDependentProduct") {
      this.headderInfo = this.findByEmp;
    } else if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductDepntTotalPlus" || this.pageName === "FindByProductSup") {
      this.headderInfo = this.findByEmp;
    } else if (
      this.pageName === 'FindByProductEnterprise' &&
      this.selectedSalesChannel === 'Enterprise' &&
      Number(this.supervisorStatus) >= 20
    ) {
      this.headderInfo = this.findBySup?.includes(' -> ')
        ? this.findBySup.substring(0, this.findBySup.lastIndexOf(' -> '))
        : this.findByProduct;
    } else if (this.pageName === "FindByProductDetailSup") {
      this.headderInfo = this.findBySup;
    } else if (this.pageName === "FindByHouseCorpCust") {
      this.headderInfo = this.findByDependentProductTotalScore;
    } else if (this.pageName === "FindHouseCorpCustByKpi") {
      this.headderInfo = this.findKpiByCust;
    } else if (this.pageName === "FindMobileLinesByKpi") {
      this.headderInfo = this.findKpiByCust;
    } else if (this.pageName === "FindKpiByCust") {
      this.headderInfo = this.findByEmp;
    }

    console.log(backPageName);
    console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));

    if (backPageName === 'search-comm-plan') {
      if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor") {
        this.router.navigate(['/search-comm-plan-sup']);
      } else {
        this.router.navigate(['/' + backPageName]);
      }
    } else if (backPageName === 'CommissionPlan') {
      this.router.navigate(['/' + backPageName]);
    } else {


      const leavingEnterpriseManagerRepDrill =
        this.pageName === 'FindByProductEnterprise' &&
        this.selectedSalesChannel === 'Enterprise' &&
        this.enterpriseManagerPlanBackup > 0;

      this.pageName = backPageName;

      this.responseList1 = [];
      this.responseList = [];
      if (backPageName === 'ListKPIs' && this.listKpisBackupCommPlanId > 0) {
        this.selectedCommPlanId = this.listKpisBackupCommPlanId;
        this.searchEmpParm = this.listKpisBackupSearchEmpParm;
        this.searchParms = this.listKpisBackupSearchParms;
      }

      if (leavingEnterpriseManagerRepDrill && backPageName === 'ListKPIs') {
        this.getHeadersAndButtons(this.selectedCommPlanId);
      } else {
        this.fetchDataByPage();
      }

      // if (this.pageName === "ListUsers") {
      //   this.findSum("true");
      //   this.responseList = this.backBtnResponseListUsers;
      // } else if (this.pageName === "ListKPIs" || this.pageName === "FindByCustByEmp") {
      //   this.findSum("true");
      //   this.responseList = this.backBtnResponseListKpis;
      // }

      // this.responseList = this.dataService.getData();

    }

  }

  roundTo(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round((num + Number.EPSILON) * 100) / 100;
  };

  redirect(url: string) {
    console.log("redirect() Called");
    this.router.navigate(['/' + url]);
  }

  backClicked() {
    this._location.back();
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public clickToCloseButton(buttonId: string, disputeForm: NgForm): void {
    document.getElementById(buttonId).click();
    disputeForm.reset();
  }

  getViewDisputeValues(resData: any) {
    console.log("getViewDisputeValues() called");
    this.view_dscempid = resData.sc_emp_id;
    this.view_dcorp = resData.corp;
    this.view_dhouse = resData.house;
    this.view_dcust = resData.cust;
    this.view_dkomfeedid = resData.kom_feed_id;
    this.view_daccnum = resData.account_number;

    if (!this.view_dkomfeedid) {
      this.view_dtrackid = this.view_daccnum;
    } else {
      this.view_dtrackid = this.view_dkomfeedid;
    }

    if (!this.view_dtrackid) {
      this.view_dtrackid = this.view_dhouse;
    }


    this.approvalFlowService.getContentMessage(this.view_dtrackid)
      .subscribe((response: WorkFlowMessageModel) => {
        this.contentMessage = response;

        this.contentMsgData = this.parseXmlToJson(this.contentMessage[0].message_content);
        this.displayedColumns = Object.keys(this.contentMsgData).map(k => k);
        this.displayedData = Object.values(this.contentMsgData).map(k => k);

        let j: number = 0;

        for (let msg of this.displayedData) {
          if (this.displayedData.length === 8) {
            if (j === 6) {
              this.disputeViewData = msg;
            }
            if (j === 7) {
              this.disputeViewKpiData = msg;
            }
          } else {
            if (j === 10) {
              this.disputeViewKpiData = msg;
            }
            if (j === 11) {
              this.disputeViewData = msg;
            }
          }

          j++;
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getAddDisputeValues(resData: any) {
    console.log("getAddDisputeValues() called");

    this.kpiid = resData.kpi_id;
    this.dependent_kpiid = resData.dpndnt_kpi_id;
    if (this.dependent_kpiid) {
      this.final_kpiid = this.dependent_kpiid;
    } else {
      this.final_kpiid = this.kpiid;
    }
    this.sc_emp_id = resData.sc_emp_id;

    this.corp = resData.corp;
    this.house = resData.house;
    this.cust = resData.cust;
    this.kom_feed_id = resData.kom_feed_id;
    this.acc_num = resData.account_number;
    this.mobfeedid = resData.mob_feed_id;

    if (resData.account_number) {
      this.recordType = "mob";
      this.disputeMsg = "<DisputeType>Dispute-Mobile</DisputeType>" + "<FinalizedDate>-</FinalizedDate>" + "<AccountNumber>" + resData.account_number + "</AccountNumber>";

    } else if (resData.kom_feed_id) {
      this.recordType = "fixed";
      this.disputeMsg = "<Corp>" + resData.corp + "</Corp>"
        + "<House>" + resData.house + "</House>" + "<CustomerName>" + resData.cust_name + "</CustomerName>" + "<CompasID>" + resData.sc_emp_id + "</CompasID>"
        + "<Revenue>" + resData.net_revenue + "</Revenue>" + "<WorDate>" + resData.wordate + "</WorDate>"
        + "<WfinDate>" + resData.wfindate + "</WfinDate>";
    } else {
      this.recordType = "manual";
      this.disputeMsg = "<Corp>" + resData.corp + "</Corp>"
        + "<House>" + resData.house + "</House>" + "<CustomerName>" + resData.cust_name + "</CustomerName>" + "<CompasID>" + resData.sc_emp_id + "</CompasID>"
        + "<Revenue>" + resData.net_revenue + "</Revenue>" + "<WorDate>" + resData.wordate + "</WorDate>"
        + "<WfinDate>" + resData.wfindate + "</WfinDate>";
    }
  }

  public insertDispute(disputeForm: NgForm): void {
    this.vkpiid = "";
    for (let val of this.missingModels) {
      this.vkpiid = this.vkpiid + val.kpi_id + ",";
    }
    this.vkpiid = this.vkpiid.replace(/,\s*$/, "");

    this.workFlowMessageModel.kpiid = this.vkpiid;
    this.workFlowMessageModel.sc_emp_id = this.sc_emp_id;
    this.workFlowMessageModel.complanid = this.selectedCommPlanId;
    this.workFlowMessageModel.complex_kpiid = this.final_kpiid;

    this.workFlowMessageModel.corp = this.corp;
    this.workFlowMessageModel.house = this.house;
    this.workFlowMessageModel.cust = this.cust;
    this.workFlowMessageModel.kom_feed_id = this.kom_feed_id;
    this.workFlowMessageModel.accnum = this.acc_num;
    this.workFlowMessageModel.mob_feed_id = this.mobfeedid
    this.workFlowMessageModel.sales_rep_id = "NA";

    this.workFlowMessageModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workFlowMessageModel.employee_id = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');
    this.workFlowMessageModel.loggedin_role = localStorage.getItem('CURRENT_USERROLE_SESSION');


    if (this.recordType === "mob") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>";
    } else if (this.recordType === "fixed") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>" + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<DisputeType>Dispute-Fixed Lines</DisputeType>" + "<Cust>" + this.workFlowMessageModel.cust + "</Cust>";
    } else if (this.recordType === "manual") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>" + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<DisputeType>Dispute-Fixed Lines-Manual</DisputeType>" + "<Cust>" + this.workFlowMessageModel.cust + "</Cust>";
    }


    this.workFlowMessageModel.recordType = this.recordType;


    this.commissionSummaryService.insertDispute(this.workFlowMessageModel).subscribe(
      (response: WorkFlowMessageModel) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully\nTicket Created");
        //this.notificationService.sendNotification(NotificationType.SUCCESS, "Ticket Created");
        this.responseList1 = [];
        this.responseList = [];
        this.fetchDataByPage();
        this.clickButton('closeAddButton');
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )

  }

  public insertMissingDispute(kpiForm: NgForm): void {
    this.vkpiid = "";
    for (let val of this.missingModels) {
      this.vkpiid = this.vkpiid + val.kpi_id + ",";
    }

    this.vkpiid = this.vkpiid.replace(/,\s*$/, "");
    kpiForm.value.kpi_id = this.vkpiid;
    kpiForm.value.message = this.missingDisputesModel.message;
    kpiForm.value.sc_emp_id = this.searchEmpParm;
    kpiForm.value.calRunId = this.selectedCalRunId;


    this.showLoading = true;
    const formData = this.missingDisputesService.createMissingForm(kpiForm.value);

    this.workFlowMessageModel.kpiid = this.vkpiid;
    this.workFlowMessageModel.sc_emp_id = this.searchEmpParm;
    this.workFlowMessageModel.calRunId = this.selectedCalRunId;
    this.workFlowMessageModel.complanid = this.selectedCommPlanId;

    this.workFlowMessageModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workFlowMessageModel.employee_id = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');
    this.workFlowMessageModel.loggedin_role = localStorage.getItem('CURRENT_USERROLE_SESSION');

    this.workFlowMessageModel.corp = this.missingDisputesModel.corp;
    this.workFlowMessageModel.house = this.missingDisputesModel.house;
    this.workFlowMessageModel.cust = this.missingDisputesModel.cust;
    this.workFlowMessageModel.cust_id = this.missingDisputesModel.cust_id;
    this.workFlowMessageModel.finalizeddate = this.missingDisputesModel.finalizeddate;
    this.workFlowMessageModel.accnumber = this.missingDisputesModel.accnumber;


    if (this.selectedMIssingDisputeVal === "f") {
      //Feed
      this.disputeMsg = "<Corp>" + this.missingDisputesModel.corp + "</Corp>"
        + "<House>" + this.missingDisputesModel.house + "</House>" + "<CustomerName>" + this.missingDisputesModel.cust_id + "</CustomerName>" +
        "<DisputeType>Missing Transaction-Fixed Lines</DisputeType>" + "<FinalizedDate>" + this.missingDisputesModel.finalizeddate + "</FinalizedDate>" + "<AccountNumber>-</AccountNumber>" + "<Message>" + this.missingDisputesModel.message + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>" + "<Cust>" + this.workFlowMessageModel.cust + "</Cust>";
    } else {
      //Mobile
      this.disputeMsg = "<DisputeType>Missing Transaction-Mobile</DisputeType>" + "<FinalizedDate>-</FinalizedDate>" + "<AccountNumber>" + this.missingDisputesModel.accnumber + "</AccountNumber>" + "<Message>" + this.missingDisputesModel.message + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>";
    }

    this.workFlowMessageModel.message_content = this.disputeMsg;

    this.addMissingDisputes.kpi_id = this.vkpiid;
    this.addMissingDisputes.message = this.missingDisputesModel.message;
    this.addMissingDisputes.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');

    this.missingDisputesService.insertMissingDisputeStatic(this.addMissingDisputes).subscribe(
      (response: CustomHttpRespone) => {
        this.clickButton('closeAddButton');
        this.insertDisputeMsg();
        kpiForm.reset();
        this.vkpiid = "";
        this.missingModels = [];

        this.missingDisputesModel.created_by = "";
        this.missingDisputesModel.created_dt = new Date();
        this.missingModels.push(this.missingDisputesModel);

        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      }
    )
  }

  public insertDisputeMsg(): void {
    this.commissionSummaryService.insertDisputeStatic(this.workFlowMessageModel).subscribe(
      (response: WorkFlowMessageModel) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully. Ticket Created");
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getActiveKpis(): void {

    this.commissionSummaryService.getKpiActiveList(this.selectedCommPlanId, localStorage.getItem('validToDt')).subscribe(
      (response: Kpimaster[]) => {
        this.kpis = response;
        this.filterKPiData = this.kpis;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  hideRemainingLabels(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  addNewRow(missingForm: NgForm) {
    const kpiObj = new MissingDisputesModel();
    kpiObj.kpi_id = this.missingDisputesModel1.kpi_id;
    kpiObj.comm_plan_id = this.missingDisputesModel1.comm_plan_id;
    this.missingModels.push(kpiObj);
  }

  public removeRow(index: any) {
    if (this.missingModels.length > 1) {
      if (this.missingModels[index].kpi_id != null) {
        this.removeFilterData(index);
      } else {
        this.removeFilterData(index);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }

  private removeFilterData(i: any) {

    if (this.missingModels.length > 0) {
      const compos = this.missingModels[i].kpi_id;
      this.missingModels.forEach((value: any, index: any) => {
        if (value.kpi_id == compos)
          this.missingModels.splice(index, 1);
      })
    }
  }

  parseXmlToJson(xml) {
    const json = {};
    for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
      const key = res[1] || res[3];
      const value = res[2] && this.parseXmlToJson(res[2]);
      json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;

    }
    return json;
  }



  public ExportToExcel() {
    this.ete.exportFromHtmlTable(this.table.nativeElement, 'ReviewCommissions');
  }



  printData() {
    window.print();
  }

  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  sort(colName) {

    this.str1 = colName;


    let j = (this.responseList.length - 1);

    if (this.str1 === this.str2) {
      if (this.pageName === "ListKPIs") {
        this.responseList[j].responsedata.sort((a: any, b: any) => a[colName] < b[colName] ? -1 : 1);
      } else {
        this.responseList[0].responsedata.sort((a: any, b: any) => a[colName] < b[colName] ? -1 : 1);
      }
      this.str2 = "";
      this.str1 = "";
    } else {
      if (this.pageName === "ListKPIs") {
        this.responseList[j].responsedata.sort((a: any, b: any) => a[colName] > b[colName] ? -1 : 1);
      } else {
        this.responseList[0].responsedata.sort((a: any, b: any) => a[colName] > b[colName] ? -1 : 1);
      }
      this.str2 = this.str1;
      this.str1 = "";
    }
  }

  addMissingDispute(btn: any) {
    this.clickButton(btn);
  }

  checkedVal(value: any) {
    this.responseList1 = [];
    this.responseList = [];
    if (value.currentTarget.checked) {
      //this.headderInfo = "";
      // this.comm_plan = "";

      localStorage.setItem('level', "1");
      // Show sup team data
      this.checkedactive = true;
      this.commSummaryModel.checkboxstatus = true;
      this.loadData();
    } else {
      localStorage.setItem('level', "0");
      // Show sup data
      this.checkedactive = false;
      this.commSummaryModel.checkboxstatus = false;
      this.loadData();
    }
  }

  noDataFound() {
    console.log("noDataFound() called");
    this.isNoDataFound = false;

    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor") {
      this.router.navigate(['/search-comm-plan-sup']);
    } else {
      this.router.navigate(['/search-comm-plan']);
    }
  }

}